const ChecklistCircle = (): JSX.Element => {
  const svgContent =
    'M128 24a104 104 0 1 0 104 104A104.2 104.2 0 0 0 128 24Zm49.5 85.8-58.6 56a8.1 8.1 0 0 1-5.6 2.2 7.7 7.7 ' +
    '0 0 1-5.5-2.2l-29.3-28a8 8 0 1 1 11-11.6l23.8 22.7 53.2-50.7a8 8 0 0 1 11 11.6Z';
  return (
    <svg viewBox="0 0 256 256" height="20px" xmlns="http://www.w3.org/2000/svg">
      .
      <path fill="none" d="M0 0h256v256H0z" />
      <path d={svgContent} fill="#ffffff" />
    </svg>
  );
};
export default ChecklistCircle;
